import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { QIcon_question_outline } from '@repo/icons/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { ScrollMenu } from 'react-horizontal-scrolling-menu'
import { useEventTracking } from '../../../helpers/gtmHelper'
import { useLogB2BClick } from '../../../modules/braze/logVisitRecord'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import { n_pricing, n_purchase, s_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useBasicPopup } from '../../basic/popup/BasicPopup'
import { PRICING_TAB } from './PricingBodyWeb.util'

export const CountdownTimer = ({ date = Date.UTC(2023, 11, 1, 15) }: { date: number | string | Date }) => {
  const targetTime = new Date(date)
  const { t } = useTranslation()

  const [timeLeft, setTimeLeft] = useState('')
  useEffect(() => {
    const updateTimer = () => {
      const now = new Date()
      const difference = targetTime.getTime() - now.getTime()

      if (difference <= 0) {
        clearInterval(timer)
        setTimeLeft('00:00:00')
        return
      }
      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((difference / 1000 / 60) % 60)
      const seconds = Math.floor((difference / 1000) % 60)

      setTimeLeft(
        days > 0
          ? `${t(n_purchase.your_cart.days(days))} ${hours.toString().padStart(2, '0')}:${minutes
              .toString()
              .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
          : `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
              .toString()
              .padStart(2, '0')}`
      )
    }
    const timer = setInterval(updateTimer, 1000)

    return () => clearInterval(timer)
  }, [])

  return <span className="leading-[140%]">{timeLeft}</span>
}

type TabScrollNavsPricingPropsType = {
  data: any
  activeId: any
  setActiveId: any
  style?: any
  md?: any
}

const PricingTabSection = ({ data, activeId, setActiveId, md, style }: TabScrollNavsPricingPropsType) => {
  const isMobile = useIsMobile()
  const tabs = data?.filter((d) => d != false && d.none != true)
  const basicPopup = useBasicPopup()
  const logB2BClick = useLogB2BClick()
  const { t } = useTranslation()
  const { sendClickEvent } = useEventTracking()

  useEffect(() => {
    if (activeId === 'b2b') {
      logB2BClick()
    }
  }, [activeId])

  const handleClickQuestion = () => {
    sendClickEvent({ button_name: 'pricing_lesson_type_question' })

    if (isMobile) {
      basicPopup.show({
        id: 'question_modal',
        title: <span className="Title2-18Bd ">{t(n_pricing.package_q.title)}</span>,
        maxW: 328,
        noClose: true,
        titlePx: 20,
        bodyPx: 20,
        overlayClose: true,
        bodyPb: 0,
        maxH: 413,
        body: (
          <div className="relative h-full">
            <div className="mb-[32px]"> {t(n_pricing.package_q.content)}</div>
            <div className="w-full sticky bottom-[0px] h-[60px] bg-white z-1 pb-[24px]">
              <DSButton
                className=""
                size={BUTTON_SIZE.MD}
                type={BUTTON_TYPE.SOLID}
                onClick={() => {
                  basicPopup.close('question_modal')
                }}
              >
                <DSButton.Label>{t(s_common.ok)}</DSButton.Label>
              </DSButton>
            </div>
          </div>
        ),
      })
    } else {
      basicPopup.show({
        id: 'question_modal',
        title: t(n_pricing.package_q.title),
        maxW: 464,
        noClose: true,
        titlePx: 20,
        bodyPx: 20,
        bodyPb: 24,
        body: (
          <div className="">
            {t(n_pricing.package_q.content)}
            <div className="w-full">
              <DSButton
                className="mt-[40px]"
                size={BUTTON_SIZE.MD}
                type={BUTTON_TYPE.SOLID}
                onClick={() => {
                  basicPopup.close('question_modal')
                }}
              >
                <DSButton.Label>{t(s_common.ok)}</DSButton.Label>
              </DSButton>
            </div>
          </div>
        ),
      })
    }
  }
  return (
    <div style={style} className="px-[20px] sm:px-[0px]">
      <div className="mt-[64px] mb-[48px] flex justify-center items-center">
        <span className="Headline1-28Bd sm:Hero3-36Bd">{t(n_pricing.package.title)}</span>
      </div>
      <div className="flex sm:flex-row flex-col justify-between sm:items-center">
        <span className="Title1-20Bd text-gray-700">{t(n_pricing.select_type.title)}</span>
        <div className="flex flex-row items-center cursor-pointer" onClick={() => handleClickQuestion()}>
          <span className="text-gray-500 Body1-16Md">{t(n_pricing.package_q.title)}</span>
          <div className="cursor-pointer">
            <QIcon_question_outline hanging={20} width={20} color={COLORS.GRAY500} />
          </div>
        </div>
      </div>
      <ScrollMenu
        wrapperClassName={'w-full transform-none mt-[16px]'}
        itemClassName={'w-full'}
        LeftArrow={<></>}
        RightArrow={<></>}
      >
        <div className="flex sm:flex-row flex-col gap-[8px] sm:gap-[20px]">
          {tabs.map((item, i) => {
            return <Tab key={i} i={i} activeId={activeId} setActiveId={setActiveId} item={item} md={md} />
          })}
        </div>
      </ScrollMenu>
    </div>
  )
}
export default PricingTabSection

const Tab = ({ activeId, setActiveId, item, md, i }) => {
  const { t, isLocaleKO } = useTranslation()
  return (
    <div
      onClick={() => setActiveId(item.id)}
      key={item.id}
      style={{ verticalAlign: 'middle' }}
      className={classNames(
        classNames(
          'flex w-full cursor-pointer items-center justify-center rounded-[8px] min-h-[134px] border-1  pt-[19px] pb-[12px] text-center relative',
          item.id == activeId ? 'bg-purple-50 border-purple-500' : ' border-gray-200 bg-white',
          md ? 'px-40' : 'px-16'
        )
      )}
    >
      {item.id == PRICING_TAB.EVERY_WEEK && (
        <div className="absolute right-[4px] top-[4px] px-[8px] py-[2px] border-1 border-red-500 text-red-500 rounded-[4px] bg-white Caption-12Bd">
          {t(n_pricing.five_percent_discount)}
        </div>
      )}
      <div className="flex items-center flex-col ">
        <span
          className={classNames('Headline3-22Bd', {
            'text-purple-600': item.id == activeId,
            'text-black': item.id != activeId,
          })}
        >
          {item.title}
        </span>
        <span
          className={classNames('Body1-16Md max-w-[280px] mt-[4px]', {
            'text-purple-400': item.id == activeId,
            'text-gray-500': item.id != activeId,
            'keep-all': isLocaleKO,
          })}
        >
          {item?.description}
        </span>
      </div>
    </div>
  )
}
